/* eslint-disable max-len */
import axios from 'axios';

const csrfToken = () =>
  document.querySelector('meta[name="csrf-token"]')?.getAttribute('content');

const instance = axios.create({
  headers: {
    Authorization: window.validationToken,
    Accept: 'application/json',
    'Content-Type': 'application/json',
  },
});

const get = (endpoint, data = {}) => instance.get(endpoint, data);

const post = (endpoint, data, options = {}) =>
  instance.post(endpoint, data, options);

const put = (endpoint, data, options = {}) =>
  instance.put(endpoint, data, options);

export const createSubscription = data =>
  post(
    window.location.origin + window.location.pathname.replace('.html', ''),
    data,
    {
      headers: { 'X-CSRF-Token': csrfToken() },
    }
  ).then(({ data: responseData }) => responseData);

// Step one of the two steps
// Allows to send the email, first, and last to braze
export const createLeadData = data =>
  put(window.location.origin + window.location.pathname, data, {
    headers: { 'X-CSRF-Token': csrfToken() },
  }).then(({ data: responseData }) => responseData);

export const getPlanInfo = () => {
  let planName = null;
  let params = {};

  if (window.location && window.location.href) {
    const afterSignupEndpoint = window.location.href.split('/signup/')[1];
    if (afterSignupEndpoint) {
      // eslint-disable prefer-destructuring
      const arr = afterSignupEndpoint.replace('.html', '').split('?');
      // eslint-disable-next-line prefer-destructuring
      planName = arr[0].match(/(\w*)/)[0];
      params = Object.fromEntries(new URLSearchParams(arr[1]));
      // eslint-enable prefer-destructuring
    }
  }

  return get(`${window.location.origin}/signup_new_data`, {
    params: {
      plan_name: planName,
      request_url: window.location.href,
      ...params,
    }
  }).then(({ data }) => data);
};

export const validateEmail = email =>
  post(
    `${window.location.origin}/email_validations`,
    { email },
    {
      headers: { 'X-CSRF-Token': csrfToken() },
    }
  ).then(response => response);

export const calculateTax = params =>
  get(
    `${window.location.origin
      + window.location.pathname.replace('.html', '')}/calculate_tax`,
    { params }
  ).then(({ data }) => data);

export const buildGoogleSignupUrl = ({ planInfo, originalSignupSource, auth0ClientId, auth0ClientDomain }) => {
  try {
    const urlEndpoint = '/authorize?';

    // params
    const responseType = 'code';
    const scope = 'openid+profile+email';
    const prompt = 'login';
    const connection = 'Google-OAuth2';
    const signupMethod = 'google';
    const planName = planInfo.plan.id;
    const signupSource = originalSignupSource;

    const urlParams = `client_id=${auth0ClientId}&response_type=${responseType}&scope=${scope}&prompt=${prompt}&connection=${connection}&signup_method=${signupMethod}&plan_name=${planName}&signup_source=${signupSource}`;

    return `https://${auth0ClientDomain}${urlEndpoint}${urlParams}`;
  } catch (e) {
    // eslint-disable-next-line no-console
    console.error(e);

    return null;
  }
};
